import { render } from "./PageCrypt.vue?vue&type=template&id=00fc54cb"
import script from "./PageCrypt.vue?vue&type=script&lang=js"
export * from "./PageCrypt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__